import React from 'react';

// Import required components
import { Heading, Service } from '../../../components';
import { services } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const Services = () => { 

  return (
    <section className='services'>

      {/* Section heading */}
      <Heading title={'Nasza oferta'} subTitle={'Co oferujemy'} />

      <Swiper
        // Install Swiper modules
        modules={[Autoplay]}
        spaceBetween={10}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
          // Define responsive breakpoints for different screen sizes
          450: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
        }} >
        
        {/* Map over the services array to render each service */}
        {services.map((service) => { 
          return (
            <SwiperSlide key={service.id}>
              <Service
                                              id={service.id}
                                              key={service.id}
                                              image={service.image}
                                              title={service.title}
                                              content={service.content} 
                                              service={service} 
                                              icon={service.icon}
                                          />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Services